import { AttachmentType, AttachmentTypePt } from './types'
import { MIME_TYPES } from '@conexasaude/conexa-hero'
import { convertMBToBytes } from './utils'

export const allowedFileExtensions = [
  'pdf',
  'docx',
  'doc',
  'xls',
  'xlsx',
  'jpg',
  'jpeg',
  'png',
]

export const ALLOWED_MIME_TYPES = [
  MIME_TYPES.pdf,
  MIME_TYPES.xls,
  MIME_TYPES.xlsx,
  MIME_TYPES.jpeg,
  MIME_TYPES.png,
]

export const MAX_FILE_SIZE_IN_MB = 7

export const MAX_FILE_SIZE = convertMBToBytes(MAX_FILE_SIZE_IN_MB)

export const MAX_FILES_LIMIT = 10

export const FILE_TYPE_GROUPS = {
  documents: ['pdf', 'docx', 'doc', 'xls', 'xlsx'],
  images: ['jpg', 'jpeg', 'png', 'gif', 'svg', 'tiff', 'bmp'],
}

export const attachmentTypes: AttachmentType[] = [
  'Exam',
  'Photo',
  'Sheet',
  'Others',
  'Prescripion',
]

export const attachmentTypesTranslation: [AttachmentType, AttachmentTypePt][] =
  [
    ['Exam', 'Exame'],
    ['Photo', 'Foto'],
    ['Sheet', 'Planilha'],
    ['Others', 'Outros'],
    ['Prescripion', 'Receita médica'],
  ]

export const maxFileSize = 7

export const medicalAttachmentTransform = {
  PENDENTE: 'pending',
  ANALISE: 'review',
  AUTORIZADO: 'finished',
  NEGADO: 'rejected',
  EXPIRADO: 'expired',
} as const

export const medicalDetailsAttachmentTransform = {
  Enviado: 'send',
  'Em Análise': 'review',
  'Solicitação Autorizada': 'finished',
  Cancelado: 'rejected',
} as const
